export default __webpack_public_path__ + "static/media/FASCIA.3d005474.png";